import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useAnalyticsEvents as useAKAnalyticsEvents, withAnalyticsEvents as withAKAnalyticsEvents } from '@atlaskit/analytics-next';
import React from 'react';
// for class based components
export function withAnalytics(BaseComponent) {
  function HOCComponent(props) {
    const fireAnalyticsEvent = prop => {
      return function (payload) {
        let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
        return prop.createAnalyticsEvent(_objectSpread({}, payload)).fire(channel);
      };
    };
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      fireAnalyticsEvent: fireAnalyticsEvent(props)
    }));
  }
  return withAKAnalyticsEvents()(HOCComponent);
}

// for functional components
export const useAnalyticsEvents = () => {
  const {
    createAnalyticsEvent
  } = useAKAnalyticsEvents();
  const handleAnalyticsEvent = function handleAnalyticsEvent(payload) {
    let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
    createAnalyticsEvent(_objectSpread({}, payload)).fire(channel);
  };
  return handleAnalyticsEvent;
};